import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { Translator } from "./translator";
import { claimMedia } from "./mediaGuard";

const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";

const FuoriRotta = () => {
  const { tourID } = useParams();
  const navigate = useNavigate();
  const { translateText, lang } = Translator();
  const [mediaType, setMediaType] = useState("photo");
  const [currentImg, setCurrentImg] = useState(0);
  //const globalAudioRef = useRef(null);
  const tourVideoRef = useRef(null);
  const [subtitleUrl, setSubtitleUrl] = useState(null);
  const [tourMuted, setTourMuted] = useState(true);
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [tour, setTour] = useState({
    title: "",
    subheading: "",
    description: "",
    image: null,
    //include: [],
    fullPrice: null,
    audioUrl: null,
    TourVideo: null,
    attrezzi: [],
  });

  const [ttsAudioUrl, setTtsAudioUrl] = useState(null);
  const audioRef = useRef(null);

  // UI strings
  const baseText = useMemo(
    () => ({
        loading: "Caricamento...",
        back: "Torna indietro",
        //includeLabel: "Include",
        noDesc: "Nessuna descrizione disponibile.",
        buyNow: "Acquista",
        addToCart: "Aggiungi al carrello",
        mustLogin: "Ti invitiamo ad effettuare prima l'accesso.",
        priceFrom: "Prezzo",
        ttsEnable: "🔇 Attiva Audio",
        ttsDisable: "🔊 Disattiva Audio",
        text31: "Foto",
        text32: "Video",
        text7: "Attrezzo",

        text16: "Scopri di più",
        text17: "➔",


        textRiprova: "Riprova",
    }),
    []
    );
  const [t, setT] = useState(baseText);

  useEffect(() => {
    (async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([k, v]) => [k, await translateText(v)])
      );
      setT(Object.fromEntries(translatedEntries));
    })();
  }, [lang, baseText, translateText]);

  // Price formatter (EUR, locale-aware)
  const formatPrice = (value, locale = navigator.language || "it-IT") =>
    new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" }).format(
      Number.isFinite(+value) ? +value : 0
    );

  // Fetch FUORIROTTA data
  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await axios.get(`${BASE}/getFuorirotta`, {
          params: { nodeID: tourID, lang },
        });

        if (typeof res.data === "string" && res.data === "0") {
          throw new Error("Tour non trovato");
        }

        const { tour: raw } = res.data || {};
        if (!raw) throw new Error("Dati non disponibili");

        const image = raw.Image ? `${BASE}/media/${raw.Image}` : null;

        const attrezzi = [];
        for (let i = 1; i <= 20; i++) {
          const imgKey = `IMGAttrezzo${i}`;
          const titleKey = `TitoloAttrezzo${i}_it`;
          const descKey = `DescAttrezzo${i}_it`;

          const imgVal = raw[imgKey];
          const titleVal = raw[titleKey] || raw[`TitoloAttrezzo${i}`];
          const descVal = raw[descKey] || raw[`DescAttrezzo${i}`];

          if (imgVal || titleVal || descVal) {
            attrezzi.push({
              index: i,
              title: titleVal || `Attrezzo ${i}`,
              description: descVal || "",
              img: imgVal ? `${BASE}/media/${imgVal}` : null,
            });
          }
        }

        setTour({
          title: raw.titelo_it || raw.titolo_it || raw.Name_it || "Fuori Rotta",
          subheading: raw.subheading_it || raw.Subheading_it || "",
          description: raw.desc_it || raw.Description_it || "",
          image,
          //include: Array.isArray(raw.include_it) ? raw.include_it : [],
          fullPrice: raw.PriceDiscounted ?? raw.FullPrice ?? raw.BasePrice ?? null,
          audioUrl: raw.TourAudio_it ? `${BASE}/media/${raw.TourAudio_it}` : null,
          TourVideo: raw.introVideo ? `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : ""}/FuoriRotta/${raw.introVideo}` : null,
          attrezzi,
        });
      } catch (e) {
        if (!cancel) setError(e?.message || "Errore sconosciuto");
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => {
      cancel = true;
    };
  }, [tourID, lang]);

  // Polly TTS fallback if no prerecorded audio
  useEffect(() => {
    (async () => {
      try {
        setTtsAudioUrl(null);
        if (!tour.description) return;
        if (tour.audioUrl) return; // prefer prerecorded

        const body = new URLSearchParams({ text: tour.description, lang });
        const res = await fetch(`${BASE}/speak`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: body.toString(),
        });
        const url = await res.text();
        if (url && typeof url === "string") setTtsAudioUrl(url);
      } catch {
        setTtsAudioUrl(null);
      }
    })();
  }, [tour.description, tour.audioUrl, lang]);

  const user = JSON.parse(localStorage.getItem("user") || "null");

  const handleAddToCart = async () => {
    if (!user || !user.email) {
      alert(t.mustLogin);
      return;
    }
    try {
      const payload = { email: user.email, tourID: parseInt(tourID, 10) };
      const res = await axios.post(`${BASE}/saveToCart`, payload);
      if (res.data?.status === "success") {
        window.dispatchEvent(new Event("showCartPopup"));
      } else {
        alert("Impossibile salvare nel carrello.");
      }
    } catch {
      alert("Si è verificato un errore durante l'aggiunta al carrello.");
    }
  };

/*
  // --------------------------------------------------------------
//  Audio Players - Prevent multiple audios from playing at once
// --------------------------------------------------------------
const handlePlay = (audioElement) => {
  if (globalAudioRef.current && globalAudioRef.current !== audioElement) {
    globalAudioRef.current.pause();
  }
  globalAudioRef.current = audioElement;
};*/


  if (loading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-slate-700">
        {t.loading}
      </div>
    );
  }
  if (error) {
    return (
      <div className="min-h-[40vh] flex flex-col items-center justify-center gap-3">
        <p className="text-red-600 font-semibold">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 rounded-md bg-[#324B8E] text-white"
        >
          {t.textRiprova}
        </button>
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Cover */}
      <div className="w-full overflow-x-hidden">
      <div className="w-full bg-[#324B8E] flex flex-col items-center">
  
  {/* Title/ */}
  <h1 className="mt-10 text-center font-bold text-3xl sm:text-4xl md:text-5xl leading-tight text-white font-['Montserrat'] break-words px-4"> {tour.title} </h1>
  
  {/* Subheading */}
  {tour.subheading && (
        <h2 className="mt-4 text-center font-medium text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] text-white mb-10">
          {tour.subheading}
        </h2>
      )}


{/* Main Image & Video */}
{/* Switch Buttons */}
<div className="flex justify-center gap-4 my-4">
  <button
    onClick={() => setMediaType("photo")}
    style={{
      backgroundColor: mediaType === "photo" ? "#49B15D" : "#ffffff",
      color: mediaType === "photo" ? "white" : "black",
      fontWeight: "bold",
      padding: "0.75rem 2rem",
      minWidth: "150px",
      borderRadius: "12px",
      border: "none",
      cursor: "pointer",
    }}
  >
    {t.text31}
  </button>

  {tour.TourVideo && (
    <button
      onClick={() => setMediaType("video")}
      style={{
        backgroundColor: mediaType === "video" ? "#49B15D" : "#ffffff",
        color: mediaType === "video" ? "white" : "black",
        fontWeight: "bold",
        padding: "0.75rem 2rem",
        minWidth: "150px",
        borderRadius: "12px",
        border: "none",
        cursor: "pointer",
      }}
    >
      {t.text32}
    </button>


  )}
</div>

{/* Display media based on toggle */}
<div className="w-full aspect-[1920/700] overflow-hidden max-w-screen">
  {mediaType === "photo" && tour.image && (
    <img
      src={tour.image}
      alt="FuoriRotta"
      className="w-full h-full object-cover"
    />
  )}

  {mediaType === "video" && tour.TourVideo && (
    <div className="relative w-full h-full">
    <video
      ref={tourVideoRef}
      key={`${tourID}-${subtitleUrl || "no-sub"}`}
      src={tour.TourVideo}
      autoPlay
      muted={tourMuted}
      loop
      controls
      playsInline
      preload="metadata"
      crossOrigin="anonymous"
      className="w-full h-full object-cover"
      onPlay={() => claimMedia(tourVideoRef.current)}
    >
    </video>
      </div>
  )}
</div>


        {/* Description */}
        <div className="w-full max-w-[100%] px-6 mt-6 mb-24 text-white">
          {tour.description ? (
            <p className="whitespace-pre-line">
              {tour.description.replace(/<\/?[^>]+(>|$)/g, "")}
            </p>
          ) : (
            <p className="italic text-slate-500">{t.noDesc}</p>
          )}
        

        {/* Audio (original or TTS) */}
        {(tour.audioUrl || ttsAudioUrl) && (
  <>
  <AudioPlayer
      src={tour.audioUrl || ttsAudioUrl}
      autoPlay={false}
      showSkipControls={false}
      showJumpControls={false}
      customAdditionalControls={[]}
      customVolumeControls={["volume"]}
      layout="horizontal-reverse"
      onPlay={(e) => claimMedia(e.target)}
    />
  </>
          
          
        )}
      </div>
  </div>
</div>


<br />
<br />
<br />
<br />






<div
  style={{
    backgroundColor: "#f2f2f2",
    width: "90%",
    textAlign: "center",
    margin: "0 auto 0.625rem auto"
  }}
>










{/* ===== ATTREZZI ===== */}
{Array.isArray(tour.attrezzi) && tour.attrezzi.length > 0 && (
  <section className="w-full bg-[#e5e7f2] flex justify-center py-10 md:py-16">
    <div className="relative w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* Prev button (desktop / tablet) */}
      <button
        type="button"
        onClick={() =>
          setCurrentImg((i) => (i === 0 ? tour.attrezzi.length - 1 : i - 1))
        }
        aria-label="Previous attrezzo"
        className="
          hidden sm:flex
          absolute -left-10 lg:-left-16 top-1/2 -translate-y-1/2
          items-center justify-center
          w-12 h-12 md:w-14 md:h-14
          text-4xl md:text-5xl font-bold
          text-[#324B8E] hover:text-[#1f3060]
          bg-[#f9fafc]/95 hover:bg-[#f9fafc]
          rounded-full shadow-lg
          focus:outline-none focus:ring-2 focus:ring-[#324B8E] focus:ring-offset-2
        "
      >
        ‹
      </button>

      {/* Slide content */}
      {(() => {
        const a = tour.attrezzi[currentImg];

        return (
          <article
            key={a.index ?? currentImg}
            className="w-full overflow-x-hidden mb-6"
          >
            {/* Attrezzo label */}
            <h4 className="text-left text-[1.6rem] sm:text-[1.8rem] font-bold text-black mb-2">
              {t.text7} {a.index ?? currentImg + 1}
            </h4>

            {/* Header box (title) */}
            <div className="w-full px-4 py-3 text-left text-base sm:text-lg font-bold bg-[#324B8E] text-white rounded-lg mb-4">
              {a.title}
            </div>

            {/* Main card */}
            <div
              className="
                bg-[#f1f3fb] rounded-2xl shadow-lg
                flex flex-col lg:flex-row gap-5 sm:gap-6
                p-4 sm:p-6 lg:p-8
                min-h-[340px] sm:min-h-[380px] lg:min-h-[420px]
              "
            >
              {/* Left: image */}
              <div className="w-full lg:w-1/2 flex items-stretch">
                {a.img ? (
                  <div className="w-full rounded-2xl overflow-hidden bg-slate-200 max-h-[min(60vh,480px)]">
                    <img
                      src={a.img}
                      alt={a.title}
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="w-full rounded-2xl bg-slate-100 border border-dashed border-slate-300 flex items-center justify-center text-slate-500 text-sm">
                    {t.noDesc}
                  </div>
                )}
              </div>

              {/* Right: description */}
              <div className="w-full lg:w-1/2 flex">
                <div className="flex flex-col justify-center w-full">
                  {a.description ? (
                    <div
                      className="
                        text-black text-justify leading-relaxed
                        text-[0.98rem] sm:text-[1.02rem]
                        whitespace-pre-line space-y-3
                        max-h-[260px] sm:max-h-[320px] lg:max-h-[360px]
                        overflow-y-auto scrollbar-none
                        pr-1
                      "
                    >
                      {a.description}
                    </div>
                  ) : (
                    <p className="italic text-slate-500 text-left">
                      {t.noDesc}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Pager dots */}
            <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
              {tour.attrezzi.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setCurrentImg(i)}
                  aria-label={`Go to slide ${i + 1}`}
                  className={`h-2.5 w-2.5 rounded-full transition-colors ${
                    i === currentImg
                      ? "bg-[#324B8E]"
                      : "bg-gray-300 hover:bg-gray-400"
                  }`}
                />
              ))}
            </div>

            {/* Mobile prev/next (bottom) */}
            <div className="mt-4 flex sm:hidden items-center justify-center gap-6">
              <button
                type="button"
                onClick={() =>
                  setCurrentImg((i) =>
                    i === 0 ? tour.attrezzi.length - 1 : i - 1
                  )
                }
                className="px-4 py-2 rounded-full border border-[#324B8E] text-[#324B8E] text-sm font-medium bg-white/90"
              >
                ‹ {currentImg + 1}/{tour.attrezzi.length}
              </button>
              <button
                type="button"
                onClick={() =>
                  setCurrentImg((i) =>
                    i === tour.attrezzi.length - 1 ? 0 : i + 1
                  )
                }
                className="px-4 py-2 rounded-full bg-[#324B8E] text-white text-sm font-medium"
              >
                {currentImg + 1}/{tour.attrezzi.length} ›
              </button>
            </div>
          </article>
        );
      })()}

      {/* Next button (desktop / tablet) */}
      <button
        type="button"
        onClick={() =>
          setCurrentImg((i) =>
            i === tour.attrezzi.length - 1 ? 0 : i + 1
          )
        }
        aria-label="Next attrezzo"
        className="
          hidden sm:flex
          absolute -right-10 lg:-right-16 top-1/2 -translate-y-1/2
          items-center justify-center
          w-12 h-12 md:w-14 md:h-14
          text-4xl md:text-5xl font-bold
          text-[#324B8E] hover:text-[#1f3060]
          bg-[#f9fafc]/95 hover:bg-[#f9fafc]
          rounded-full shadow-lg
          focus:outline-none focus:ring-2 focus:ring-[#324B8E] focus:ring-offset-2
        "
      >
        ›
      </button>
    </div>
  </section>
)}

  






        {/* Back link */}
        <div className="mt-12 mb-16">
          <button
            onClick={() => navigate(-1)}
            className="text-[#324B8E] font-semibold"
          >
            ← {t.back}
          </button>
        </div>


        </div>
      </div>
  );
};

export default FuoriRotta;
